var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"images-page",class:_vm.type},_vm._l((_vm.IMAGES[_vm.type]),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }